import Component from '../abstracts/Component';

export default class SearchComponent extends Component {
  get SELECTORS() {
    return {
      searchInput: '[data-search-input]',
      resetSearchBtn: '[data-search-reset]',
      searchSubmitBtn: '[data-search-submit]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.searchInput = this.$component.querySelector(this.SELECTORS.searchInput);
    this.resetSearchBtn = this.$component.querySelector(this.SELECTORS.resetSearchBtn);
    this.searchSubmitBtn = this.$component.querySelector(this.SELECTORS.searchSubmitBtn);
  }

  render() {
    super.render();
    this.bindEvents();
  }

  bindEvents() {
    if(this.resetSearchBtn && this.searchSubmitBtn && this.searchInput) {
      // handle reset input
      this.resetSearchBtn.addEventListener('click', event => {
        event.preventDefault();
        this.searchInput.value = '';
        this.resetSearchBtn.classList.add("hidden");
        this.searchSubmitBtn.classList.remove("hidden");
        this.searchInput.focus();
      });
      //handle search input
      this.searchInput.addEventListener('input', event => {
        if(event.currentTarget.value.length > 0) {
          this.searchSubmitBtn.classList.add("active");
          this.resetSearchBtn.classList.add("hidden");
          this.searchSubmitBtn.classList.remove("hidden");
        } else {
          this.searchSubmitBtn.classList.remove("active");
        }
      });
    }

  }
}
